(function () {
  if (window.__OBSIDIA_PRODUCT_GATE__) return;
  window.__OBSIDIA_PRODUCT_GATE__ = true;

  var RESTRICTED_SKUS = [
    'BR10011',
    'BR10015',
    'BR10016',
    'R13660',
    'R13657',
    'R13046',
    'R13769',
    'BR10017',
    'R13771',
    'R13782',
    'R13779',
    'BR10018',
    'R13814',
    'R12841',
    'R13840',
    'R13842',
    'R13847',
    'R12566',
    'R13626',
    'R13910',
    'R13866',
    'R13898',
    'BR10020',
    'R13780',
    'R13919',
    'R13920',
    'GIVEAWAY',
    'R13879',
    'R13929',
    'R13928',
    'R13870',
    'R13874',
    'BR10021',
    'R13869',
    'BR10022',
    'R13961',
    'R13968',
    'R13970',
    'R13971',
    'R13992',
    'R13930',
    'R13931',
    'R13932',
    'BR10023',
    'R13994',
    'R13995',
    'BR10024',
    'R14069',
    'R13208',
    'R13037',
    'R14071',
    'R14030',
    'R14032',
    'R14088',
    'R14098',
    'R14034',
    'R12842',
    'R13447',
    'R14166',
    'R14165',
    'R14137',
    'R14150',
    'R14151',
    'R14153',
    'R14154',
    'R14155',
    'R14156',
    'R14131',
    'R14133',
    'R14134'
  ];

  var restricted = {};

  RESTRICTED_SKUS.forEach(function (sku) {
    restricted[normalise(sku)] = true;
  });

  function normalise(value) {
    return (value || '')
      .toString()
      .trim()
      .toUpperCase();
  }

  function parseJSON(value, fallback) {
    try {
      return JSON.parse(value || '');
    } catch (error) {
      return fallback;
    }
  }

  function isRestricted(sku) {
    return restricted[normalise(sku)] === true;
  }

  function getCustomerContext(element) {
    if (!element) {
      return {
        loggedIn: false,
        tags: []
      };
    }

    return {
      loggedIn:
        element.getAttribute('data-obsidia-logged-in') === 'true',

      tags: parseJSON(
        element.getAttribute('data-obsidia-customer-tags'),
        []
      )
    };
  }

  function customerHasSku(context, sku) {
    if (!context.loggedIn) return false;

    var wanted = normalise(sku);

    for (var i = 0; i < context.tags.length; i++) {
      if (normalise(context.tags[i]) === wanted) {
        return true;
      }
    }

    return false;
  }

  function isBlocked(context, sku) {
    return (
      isRestricted(sku) &&
      !customerHasSku(context, sku)
    );
  }

  function blockedMessage(context) {
    return context.loggedIn
      ? 'Invite only. Join the lottery to be considered.'
      : 'Please log in to purchase this product.';
  }

  function showCardError(button, message) {
    var wrapper =
      button.closest(
        '.product-card--add-to-cart-button-wrapper'
      ) ||
      button.parentElement;

    if (!wrapper) return;

    var error =
      wrapper.querySelector('.fc-gate-error');

    if (!error) {
      error = document.createElement('div');
      error.className =
        'fc-gate-error form-notification error';
      error.style.marginTop = '8px';
      wrapper.appendChild(error);
    }

    error.textContent = message;
    error.style.display = '';
  }

  function clearCardError(button) {
    var wrapper =
      button.closest(
        '.product-card--add-to-cart-button-wrapper'
      );

    if (!wrapper) return;

    var error =
      wrapper.querySelector('.fc-gate-error');

    if (error) {
      error.textContent = '';
      error.style.display = 'none';
    }
  }

  function getProductForm(element) {
    if (!element) return null;

    var direct =
      element.closest &&
      element.closest(
        'product-form[data-obsidia-product-form]'
      );

    if (direct) return direct;

    var section =
      element.closest &&
      element.closest('[id^="shopify-section-"]');

    if (section) {
      var sectionForm =
        section.querySelector(
          'product-form[data-obsidia-product-form]'
        );

      if (sectionForm) return sectionForm;
    }

    return document.querySelector(
      'product-form[data-obsidia-product-form]'
    );
  }

  function getVariants(productForm) {
    return parseJSON(
      productForm.getAttribute(
        'data-obsidia-variants'
      ),
      []
    );
  }

  function getSelectedVariant(productForm) {
    var form =
      productForm.querySelector(
        'form[data-type="add-to-cart-form"]'
      );

    if (!form) return null;

    var idInput =
      form.querySelector('input[name="id"]');

    if (!idInput || !idInput.value) {
      return null;
    }

    var id = String(idInput.value);
    var variants = getVariants(productForm);

    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === id) {
        return variants[i];
      }
    }

    return null;
  }

  function getFormState(productForm) {
    var variant =
      getSelectedVariant(productForm);

    var context =
      getCustomerContext(productForm);

    var sku =
      variant && variant.sku
        ? variant.sku
        : '';

    var available =
      variant
        ? variant.available === true
        : false;

    return {
      context: context,
      sku: sku,
      available: available,
      blocked: isBlocked(context, sku)
    };
  }

  function showProductError(
    productForm,
    message
  ) {
    var wrapper =
      productForm.querySelector(
        '.product-form__error-message-wrapper'
      );

    if (!wrapper) return;

    var text =
      wrapper.querySelector(
        '.product-form__error-message'
      );

    if (!text) return;

    text.textContent = message;
    wrapper.hidden = false;
    wrapper.style.display = '';

    if (
      typeof wrapper.scrollIntoView ===
      'function'
    ) {
      wrapper.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }
  }

  function clearProductError(productForm) {
    var wrapper =
      productForm.querySelector(
        '.product-form__error-message-wrapper'
      );

    if (!wrapper) return;

    var text =
      wrapper.querySelector(
        '.product-form__error-message'
      );

    if (text) {
      text.textContent = '';
    }

    wrapper.hidden = true;
    wrapper.style.display = 'none';
  }

  function getProductButtons(productForm) {
    var buttons = [];

    var main =
      productForm.querySelector('#AddToCart');

    if (main) {
      buttons.push(main);
    }

    var sectionId =
      productForm.getAttribute(
        'data-section'
      );

    if (sectionId) {
      var section =
        document.getElementById(
          'shopify-section-' + sectionId
        );

      if (section) {
        var sticky =
          section.querySelector(
            '#AddToCartSticky'
          );

        if (
          sticky &&
          buttons.indexOf(sticky) === -1
        ) {
          buttons.push(sticky);
        }
      }
    }

    var globalSticky =
      document.getElementById(
        'AddToCartSticky'
      );

    if (
      globalSticky &&
      buttons.indexOf(globalSticky) === -1
    ) {
      buttons.push(globalSticky);
    }

    return buttons;
  }

  function updateProductForm(productForm) {
    if (!productForm) return;

    var state =
      getFormState(productForm);

    var buttons =
      getProductButtons(productForm);

    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];

      button.dataset.obsidiaBlocked =
        state.blocked ? '1' : '0';

      button.classList.toggle(
        'sold-out',
        state.blocked || !state.available
      );

      button.classList.toggle(
        'accent',
        state.available && !state.blocked
      );

      if (state.blocked) {
        button.type = 'button';

        button.removeAttribute(
          'disabled'
        );

        button.setAttribute(
          'aria-disabled',
          'true'
        );

        button.setAttribute(
          'title',
          blockedMessage(state.context)
        );
      } else {
        button.type = 'submit';

        button.removeAttribute(
          'aria-disabled'
        );

        button.removeAttribute(
          'title'
        );

        if (state.available) {
          button.removeAttribute(
            'disabled'
          );
        } else {
          button.setAttribute(
            'disabled',
            'disabled'
          );
        }
      }
    }

    var paymentButton =
      productForm.querySelector(
        '.shopify-payment-button'
      );

    if (paymentButton) {
      if (state.blocked) {
        paymentButton.style.display =
          'none';
      } else {
        paymentButton.style.removeProperty(
          'display'
        );
      }
    }

    if (!state.blocked) {
      clearProductError(productForm);
    }
  }

  function initialiseProductForm(
    productForm
  ) {
    if (
      !productForm ||
      productForm.dataset
        .obsidiaGateInitialised === '1'
    ) {
      return;
    }

    productForm.dataset
      .obsidiaGateInitialised = '1';

    var idInput =
      productForm.querySelector(
        'input[name="id"]'
      );

    if (
      idInput &&
      'MutationObserver' in window
    ) {
      new MutationObserver(
        function () {
          updateProductForm(
            productForm
          );
        }
      ).observe(idInput, {
        attributes: true,
        attributeFilter: ['value']
      });
    }

    updateProductForm(productForm);
  }

  function initialiseAllForms() {
    var forms =
      document.querySelectorAll(
        'product-form[data-obsidia-product-form]'
      );

    for (
      var i = 0;
      i < forms.length;
      i++
    ) {
      initialiseProductForm(forms[i]);
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var cardButton =
        event.target.closest &&
        event.target.closest(
          'button.product-card--add-to-cart-button-simple[data-sku]'
        );

      if (cardButton) {
        clearCardError(cardButton);

        var card =
          cardButton.closest(
            'product-card[data-obsidia-product-card]'
          );

        if (!card) return;

        var sku =
          cardButton.getAttribute(
            'data-sku'
          ) || '';

        var cardContext =
          getCustomerContext(card);

        if (
          isBlocked(
            cardContext,
            sku
          )
        ) {
          event.preventDefault();
          event.stopPropagation();

          if (
            event.stopImmediatePropagation
          ) {
            event.stopImmediatePropagation();
          }

          showCardError(
            cardButton,
            blockedMessage(cardContext)
          );

          return false;
        }

        return;
      }

      var productButton =
        event.target.closest &&
        event.target.closest(
          '#AddToCart, #AddToCartSticky'
        );

      if (!productButton) return;

      var productForm =
        getProductForm(productButton);

      if (!productForm) return;

      var state =
        getFormState(productForm);

      if (!state.blocked) return;

      event.preventDefault();
      event.stopPropagation();

      if (
        event.stopImmediatePropagation
      ) {
        event.stopImmediatePropagation();
      }

      showProductError(
        productForm,
        blockedMessage(state.context)
      );

      return false;
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;

      if (
        !form ||
        !form.closest
      ) {
        return;
      }

      var productForm =
        form.closest(
          'product-form[data-obsidia-product-form]'
        );

      if (!productForm) return;

      var state =
        getFormState(productForm);

      if (!state.blocked) return;

      event.preventDefault();
      event.stopPropagation();

      if (
        event.stopImmediatePropagation
      ) {
        event.stopImmediatePropagation();
      }

      showProductError(
        productForm,
        blockedMessage(state.context)
      );
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      var productForm =
        getProductForm(event.target);

      if (!productForm) return;

      window.setTimeout(
        function () {
          updateProductForm(
            productForm
          );
        },
        0
      );
    }
  );

  document.addEventListener(
    'input',
    function (event) {
      if (
        !event.target ||
        event.target.name !== 'id'
      ) {
        return;
      }

      var productForm =
        getProductForm(event.target);

      if (!productForm) return;

      window.setTimeout(
        function () {
          updateProductForm(
            productForm
          );
        },
        0
      );
    }
  );

  document.addEventListener(
    'shopify:section:load',
    function () {
      initialiseAllForms();
    }
  );

  if (
    'MutationObserver' in window
  ) {
    new MutationObserver(
      function (mutations) {
        for (
          var i = 0;
          i < mutations.length;
          i++
        ) {
          if (
            mutations[i].addedNodes &&
            mutations[i].addedNodes.length
          ) {
            initialiseAllForms();
            break;
          }
        }
      }
    ).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initialiseAllForms
    );
  } else {
    initialiseAllForms();
  }
})();